import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import LoadingDots from "../data-display/LoadingDots";

type PriceUpdateModalProps = {
  modalSize?: string;
  isOpen: boolean;
  onClose: () => void;
  getTotal: (price: number) => number;
  currentPrice?: number;
  onPriceUpdate: (price?: number) => void;
  placeholder?: string;
};

export const PriceUpdateModal = ({
  modalSize = "sm",
  isOpen,
  onClose,
  getTotal,
  currentPrice = 0,
  onPriceUpdate,
  placeholder = "The new hourly rate to use for the tutor",
}: PriceUpdateModalProps) => {
  const [price, onPriceChange] = React.useState(currentPrice);

  useEffect(() => {
    onPriceChange(currentPrice);
  }, [currentPrice]);

  const updatePrice = () => {
    onPriceUpdate(price);
  };
  return (
    <Modal size={modalSize} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        py={[6, 6]}
        px={[6, 8]}
        rounded="fbRadius"
        overflow="hidden"
      >
        <ModalHeader />
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>Input the new price</FormLabel>
            <Input
              size="lg"
              fontSize="16px"
              value={price}
              type="number"
              onChange={(e) => onPriceChange(+e.target.value)}
              placeholder={placeholder}
            />
            <Flex direction="row" justifyContent="space-between">
              <Button onClick={updatePrice}>Update</Button>
              <Box boxSize={"20px"} />
              <Text alignSelf="center">
                Total: {getTotal(price).toFixed(2)}
              </Text>
            </Flex>
          </FormControl>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

const PriceDisplay = ({
  priceIsFetched,
  price,
  currency,
  getTotal,
  hourlyRate,
  isMinus = false,
  isAdmin = false,
  onChangeRate,
  ...rest
}: any) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  return (
    <>
      {isAdmin ? (
        <PriceUpdateModal
          isOpen={isOpen}
          getTotal={getTotal}
          currentPrice={hourlyRate}
          onClose={onClose}
          onPriceUpdate={(...rest) => {
            onChangeRate(...rest);
            onClose();
          }}
        />
      ) : null}
      <Box {...rest}>
        {priceIsFetched ? (
          <Stack isInline align="center">
            {isMinus && <Text>&minus;</Text>}
            <Text
              cursor={isAdmin ? "pointer" : "none"}
              onClick={isAdmin ? onOpen : undefined}
            >
              {currency + price.toLocaleString()}
            </Text>
          </Stack>
        ) : (
          <LoadingDots />
        )}
      </Box>
    </>
  );
};

export default PriceDisplay;

PriceDisplay.defaultProps = {
  fontWeight: "medium",
  fontSize: "md",
  lineHeight: "none",
};
